export default "__VITE_PUBLIC_ASSET__42263714__"